<template>
  <!-- Table Container Card -->
  <b-card :title="$t('operation.users')">
    <!-- Delete Model -->
    <DeleteModal modal-id="modal-delete" @deleteToggle="deleteUser" />

    <!-- Edit modal -->
    <b-modal
      id="modal-edit"
      :no-close-on-backdrop="true"
      ok-only
      :ok-title="$t('common.ok')"
      centered
      size="lg"
      :title="`${$t('common.edit')} ${$t('operation.user')}`"
      @ok="updateItem()"
    >
      <b-card-text>
        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('common.name')">
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('common.name')"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('operation.email')">
              <b-form-input
                v-model="EditForm.email"
                :placeholder="$t('operation.email')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group :label="$t('warehouse.department')">
              <AutoComplete
                v-model="EditForm.department_id"
                :placeholder="`${$t('common.select')} ${$t(
                  'warehouse.department'
                )}`"
                :serializer="(val) => val.id"
                param-query="search"
                endpoint="departments"
                text-title="name"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <div
              v-for="(item, index) in userRols"
              :key="index"
              class="mt-2 mt-md-0 w-100 mx-1"
            >
              <b-row>
                <b-col md="10" cols="12">
                  <AutoComplete
                    v-model="userRols[index]"
                    :label="$t('operation.roles')"
                    :placeholder="$t('operation.roles')"
                    :serializer="(val) => val.id"
                    param-query="search"
                    endpoint="role"
                    text-title="name"
                  />
                </b-col>

                <b-col
                  class="d-flex align-items-center w-full"
                  md="2"
                  cols="12"
                >
                  <b-button
                    class="mx-1 w-full"
                    variant="primary"
                    size="sm"
                    @click="addDoctor"
                    >+</b-button
                  >
                  <b-button
                    :disabled="index === 0"
                    size="sm"
                    variant="danger"
                    @click="removeDoctor(index)"
                    >X</b-button
                  >
                </b-col>
              </b-row>
            </div>
            <!-- <AutoComplete
              :label="$t('operation.roles')"
              :placeholder="`${$t('common.select')} ${$t('operation.role')}`"
              v-model="EditForm.role_id"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="role"
              text-title="name"
            /> -->
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>

    <!-- Change Password Modal -->
    <b-modal
      id="modal-change-password"
      :no-close-on-backdrop="true"
      ok-only
      :ok-title="$t('common.ok')"
      centered
      size="md"
      :title="`${$t('common.change')} ${$t('operation.password')}`"
      @ok="changePassword()"
    >
      <b-card-text>
        <b-row>
          <b-col md="12">
            <b-form-group :label="$t('operation.newPassword')">
              <b-form-input
                v-model="passwordForm.password"
                type="password"
                :placeholder="$t('operation.newPassword')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <!-- add Page -->
    <div class="m-2" />
    <div class="m-2">
      <!-- Search -->
      <b-row>
        <b-col md="10">
          <b-form-group :label="$t('common.name')">
            <b-form-input
              v-model="filterData.name"
              :placeholder="$t('common.name')"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="2"
          class="d-flex align-items-center justify-content-start mt-1"
        >
          <b-button variant="primary" @click="index()">
            {{ $t("common.search") }}
          </b-button>
        </b-col>
      </b-row>
    </div>
    <b-row class="my-2">
      <b-col
        cols="12"
        md="12"
        class="d-flex align-items-center justify-content-between mb-1 mb-md-0"
      >
        <h3>{{ $t("common.table") }} {{ $t("operation.users") }}</h3>
        <b-button
          v-if="$store.state.app.permissions.includes('store-user')"
          variant="primary"
          @click="$router.push({ name: 'add-users' })"
        >
          {{ $t("common.add") }} {{ $t("operation.user") }}
        </b-button>
      </b-col>
    </b-row>
    <!-- Data Table  -->
    <b-table
      v-if="!loading"
      :items="usersData"
      responsive
      :fields="tableColumns"
      primary-key="id"
      show-empty
      empty-text="No matching records found"
      class="position-relative"
    >
      <!-- Column: Id -->
      <template #cell(id)="data">
        <b-link
          :to="{ name: 'city', params: { id: data.item.id } }"
          class="font-weight-bold"
        >
          {{ data.item.id }}
        </b-link>
      </template>

      <!-- Column: Username -->
      <template #cell(Username)="data">
        <span class="text-nowrap">
          {{ data.item.username }}
        </span>
      </template>

      <!-- Column: Phone -->
      <template #cell(Phone)="data">
        <span class="text-nowrap">
          {{ data.item.phone }}
        </span>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <div class="d-flex flex-wrap align-items-center gap-1">
          <b-button
            pill
            variant="outline-primary"
            size="sm"
            @click="
              $router.push({
                name: 'users-preview',
                params: { id: data.item.id },
              })
            "
          >
            <feather-icon icon="KeyIcon" size="14" class="mr-50" />
            {{ $t("operation.permissions") }}
          </b-button>
          <b-button
            pill
            variant="outline-warning"
            size="sm"
            @click="showPasswordModal(data.item)"
          >
            <feather-icon icon="LockIcon" size="14" class="mr-50" />
            {{ $t("operation.changePassword") }}
          </b-button>
          <ActionsButtons
            delete-perm="delete-user"
            edit-perm="update-user"
            @editToggle="show(data.item)"
            @deleteToggle="deleteModel(data.item)"
          />
        </div>
      </template>
    </b-table>
    <template v-if="loading">
      <div>
        <div class="d-flex justify-content-center mb-1">
          <b-spinner :label="$t('common.loading')" />
        </div>
      </div>
    </template>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted"
            >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
            {{ $t("operation.users") }}</span
          >
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
          @click="index()"
        >
          <b-pagination
            v-model="page"
            :total-rows="totalRows"
            :per-page="take"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BModal,
  BAlert,
  VBModal,
  BCardText,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";

const AutoComplete = () => import("@/components/common/AutoComplete.vue");
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BAlert,
    BCardText,
    AutoComplete,
    ActionsButtons,
    DeleteModal,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      tableColumns: [
        // { key: "Id", label: "#", sortable: true },
        { key: "name", label: this.$t("common.name"), sortable: true },
        { key: "email", label: this.$t("operation.email"), sortable: true },
        {
          key: "departments[0].name",
          label: this.$t("warehouse.department"),
          sortable: true,
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      EditForm: {
        name: "",
        email: "",
        role_id: "",
        department_id: null,
        _method: "PUT",
      },
      take: 10,
      loading: true,
      selected: "",
      totalInvoices: 0,
      option: [],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      totalRows: "",
      page: 1,
      params: {
        form: {},
        path: "",
      },
      deleteForm: [],
      statusFilter: null,
      departmentList: [],
      jobTitleList: [],
      include: "department,jobTitle",
      usersData: "",
      filterData: {
        name: "",
      },
      userRols: [""],
      passwordForm: {
        id: "",
        password: "",
        _method: "PUT",
      },
    };
  },

  mounted() {
    this.index();
  },
  methods: {
    show(item) {
      // Check if user can be edited
      if (!item) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            variant: "danger",
            text: "Unable to load user data",
          },
        });
        return;
      }

      try {
        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.email = item.email;

        // Set department_id as object for AutoComplete
        if (item.departments && item.departments.length > 0) {
          this.EditForm.department_id = {
            id: item.departments[0].id,
            name: item.departments[0].name,
          };
        } else {
          this.EditForm.department_id = null;
        }

        // Load roles as objects for AutoComplete
        // The roles array already contains role objects with id and name
        if (item.roles && item.roles.length > 0) {
          // Use the role objects directly (they should have id and name properties)
          this.userRols = item.roles
            .filter((role) => role != null)
            .map((role) => {
              // Handle different role structures
              let roleId = null;
              let roleName = "";

              if (role.id) {
                roleId = role.id;
                roleName = role.name || "";
              } else if (role.pivot && role.pivot.role_id) {
                roleId = role.pivot.role_id;
                roleName = role.name || "";
              }

              return roleId
                ? {
                    id: roleId,
                    name: roleName,
                  }
                : null;
            })
            .filter((role) => role != null);

          // Ensure at least one empty role field
          if (this.userRols.length === 0) {
            this.userRols = [""];
          }
        } else {
          this.userRols = [""];
        }

        this.$bvModal.show("modal-edit");
      } catch (error) {
        console.error("Error loading user for edit:", {
          error: error.message,
          stack: error.stack,
          item: {
            id: item?.id,
            name: item?.name,
            hasRoles: !!item?.roles,
            rolesType: typeof item?.roles,
            rolesSample: Array.isArray(item?.roles)
              ? item.roles[0]
              : "not-array",
            hasDepartments: !!item?.departments,
            departmentsType: typeof item?.departments,
          },
        });
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            variant: "danger",
            text: `Unable to edit this user. Error: ${error.message}`,
          },
        });
      }
    },
    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    showPasswordModal(item) {
      this.passwordForm.id = item.id;
      this.passwordForm.password = "";
      this.$bvModal.show("modal-change-password");
    },
    changePassword() {
      if (!this.passwordForm.password) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Validation Error",
            variant: "danger",
            text: "Password is required",
          },
        });
        return;
      }

      this.params.form = {
        password: this.passwordForm.password,
        _method: "PUT",
      };
      this.params.path = `/user/${this.passwordForm.id}`;
      this.$store
        .dispatch("update", this.params)
        .then((response) => {
          this.index();
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Success",
              icon: "CheckIcon",
              variant: "success",
              text: "Password changed successfully",
            },
          });
          this.passwordForm.password = "";
        })
        .catch((error) => {
          if (error.response && error.response.status === 400) {
            for (const item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Validation Error",
                  variant: "danger",
                  text: error.response.data[item][0],
                },
              });
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Error",
                variant: "danger",
                text: "Error changing password",
              },
            });
          }
        });
    },
    addDoctor() {
      this.userRols.push("");
    },

    removeDoctor(index) {
      if (index === 0) return;
      this.userRols.splice(index, 1);
    },

    async index() {
      this.loading = true;

      let url = `/user?take=${this.take}&page=${this.page}&sort=-id&include=roles,departments`;

      if (this.filterData.name) {
        url += `&filter[name]=${this.filterData.name}`;
      }

      await this.getList(url);
      this.totalRows = this.all_data.total;
      this.usersData = this.all_data.data;
      this.loading = false;
    },
    async asignRole() {
      // Extract IDs from userRols array, handling both objects and strings
      const roleIds = this.userRols
        .filter((role) => role !== "" && role != null)
        .map((role) => {
          if (typeof role === "object" && role !== null && role.id) {
            return role.id;
          }
          return role;
        });

      if (roleIds.length === 0) {
        return Promise.resolve();
      }

      this.params.form = { roleIds };
      this.params.path = `/assign-role-to/user/${this.EditForm.id}`;

      return this.$store
        .dispatch("create", this.params)
        .then((response) => response)
        .catch((error) => {
          if (error.response && error.response.status === 400) {
            for (const item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "validation error",
                  variant: "danger",
                  text: error.response.data[item][0],
                },
              });
            }
          }
          throw error;
        });
    },
    async updateItem() {
      try {
        // Update user basic info first
        const updateForm = { ...this.EditForm };

        if (
          updateForm.name &&
          typeof updateForm.name === "object" &&
          updateForm.name.title
        ) {
          updateForm.name = updateForm.name.title;
        }

        if (
          updateForm.department_id &&
          typeof updateForm.department_id === "object"
        ) {
          updateForm.department_id = updateForm.department_id.id;
        }

        if (updateForm.department_id == null) {
          delete updateForm.department_id;
        }

        // Update user info
        this.params.form = updateForm;
        this.params.path = `/user/${this.EditForm.id}`;

        await this.$store.dispatch("update", this.params);

        // Then assign roles
        await this.asignRole();

        // Refresh the list
        await this.index();

        // Close modal and show success
        this.$bvModal.hide("modal-edit");
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Success",
            icon: "CheckIcon",
            variant: "success",
            text: "User updated successfully",
          },
        });
      } catch (error) {
        if (error.response && error.response.status === 400) {
          for (const item in error.response.data) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "validation error",
                variant: "danger",
                text: error.response.data[item][0],
              },
            });
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error updating user",
            },
          });
        }
      }
    },
    deleteUser() {
      this.$store
        .dispatch("delete", `/user/${this.deleteForm.id}`)
        .then((response) => {
          this.index();
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: `deleted ${this.deleteForm.name} successfully`,
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: `Error deleting ${this.deleteForm.name}`,
            },
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
